import React from "react";
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import CollapsibleContainer from "../../../common/components/CollapsibleContainer";
import CountryPricingRowV2 from "./CountryPricingRowV2";
import {Button} from "semantic-ui-react";
import {connect} from "react-redux";
import {toggleAddCountryPricingModalV2, toggleAddPricingSchemeModalV2} from "../actions/PricingTablesActions";

export class CountryPriceTables extends React.Component {

    static propTypes = {
        pricingID: PropTypes.string,
        countryPriceTables: PropTypes.object,
    }

    handleAddCountry = (e, {pricing_scheme, obj_key}) => {
        this.props.toggleAddCountryPricingModalV2(this.props.pricingID, pricing_scheme, obj_key);
    }

    handleAddPricingScheme = () => {
        const volumeAggregationType = this.props.pricingTableDetailsV2.volume_aggregation_type;
        this.props.toggleAddNewPricingScheme(this.props.pricingID, volumeAggregationType);
    }

    getTableHeaders(value, key) {
        let header = [<Table.Header key="countries">Country</Table.Header>];

        if (value.pricing_scheme === "FLAT") {
            header.push(<Table.Header key="price">Price</Table.Header>)
        } else {
            value.pricing_json.forEach(function(item){
                let min = item.min;
                let max = item.max;
                if (item.min === 0) {
                    min = '<= ';
                }
                if (item.max === null) {
                    max = min;
                    min = '>= ';
                }
                if (item.min && item.max) {
                    min = min + ' - ';
                }
                header.push(<Table.Header key={'tier' + min + max}>{min}{max}</Table.Header>)
            });
        }
        if (this.props.canEdit) {
            header.push(<Table.Header key="edit-delete" className={"edit-records"}>
                <Button
                    obj_key={value.pricing_json}
                    pricing_scheme={value.pricing_scheme}
                    size={"mini"}
                    icon="add"
                    content="Add Country"
                    onClick={this.handleAddCountry}
                />
            </Table.Header>)
        }
        return header;
    }

    render() {
        const { countryPriceTables, canEdit } = this.props;
        return (
            <div className={"country-pricing-tables"}>
                {canEdit ? (
                        <div className={"pricing-table-bar"}>
                            <Button
                                size={"mini"}
                                icon="add"
                                content="Add New Pricing Scheme"
                                onClick={this.handleAddPricingScheme}
                            />
                        </div>
                    )
                    : null }
                {Object.entries(countryPriceTables).map(([key, value], idx) => (
                    <CollapsibleContainer
                        open={idx === 0}
                        title={'Pricing Scheme: ' + key}
                        id={idx}
                        key={idx}
                    >
                        <Table
                            headers={this.getTableHeaders(value[0], key)}
                            className={"pricing-table"}
                        >
                            {Object.values(value).map((item, idx) => (
                                <CountryPricingRowV2
                                    key={idx}
                                    countryRecord={item}
                                />
                            ))}
                        </Table>
                    </CollapsibleContainer>
                ))}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    pricingTableDetailsV2: state.billing.pricing.pricingTableDetailsV2,
    canEdit: state.marvel.user.access.accessLevel.isPricingAdmin,
});

const mapDispatchToProps = dispatch => ({
    toggleAddCountryPricingModalV2: (pricingID, pricingScheme, pricingJsonKey) => {
        dispatch(toggleAddCountryPricingModalV2(pricingID, pricingScheme, pricingJsonKey))},
    toggleAddNewPricingScheme: (pricingID, volumeAggregationType) => {
        dispatch(toggleAddPricingSchemeModalV2(pricingID, volumeAggregationType))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CountryPriceTables);
